import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShoppingCartIconComponent } from './cart-icon.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
    declarations: [
        ShoppingCartIconComponent,
    ],
    imports: [
        CommonModule,
        IonicModule,
    ],
    exports: [
        ShoppingCartIconComponent
    ],
    providers: [],
})
export class ShoppingCartIconModule { }
